// extracted by mini-css-extract-plugin
module.exports = {"iframeContainer":"EmbedBlock_iframeContainer__q6yB3","instagramContainer":"EmbedBlock_instagramContainer__NweHq"};